import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-primary-dark">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="mb-6">
          <Link
            to="/login"
            className="inline-flex items-center space-x-2 space-x-reverse text-accent-gold hover:text-accent-gold/80 transition-colors"
          >
            <ArrowRight className="h-5 w-5" />
            <span>العودة للصفحة الرئيسية</span>
          </Link>
        </div>

        <div className="bg-secondary-dark rounded-lg border border-primary-light p-8">
          <h1 className="text-3xl font-bold text-text-primary mb-6 text-center">
            سياسة الخصوصية
          </h1>

          <div className="space-y-6 text-text-secondary leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                1. جمع المعلومات
              </h2>
              <p>
                نحن نجمع المعلومات التي تقدمها لنا مباشرة عند استخدام تطبيق المسجد، بما في ذلك:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>الاسم وعنوان البريد الإلكتروني</li>
                <li>رقم الهاتف (اختياري)</li>
                <li>معلومات التسجيل في الفعاليات</li>
                <li>حجوزات القاعات</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                2. استخدام المعلومات
              </h2>
              <p>
                نستخدم المعلومات التي نجمعها للأغراض التالية:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>تقديم وتحسين خدمات التطبيق</li>
                <li>إرسال الإشعارات المتعلقة بأوقات الصلاة والفعاليات</li>
                <li>إدارة حجوزات القاعات والتسجيل في الفعاليات</li>
                <li>التواصل معك بخصوص الخدمات المقدمة</li>
                <li>تحليل استخدام التطبيق لتحسين الأداء</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                3. مشاركة المعلومات
              </h2>
              <p>
                نحن لا نبيع أو نشارك معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>عند الحصول على موافقتك الصريحة</li>
                <li>للامتثال للقوانين واللوائح</li>
                <li>لحماية حقوق وسلامة المستخدمين الآخرين</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                4. حماية البيانات
              </h2>
              <p>
                نتخذ تدابير أمنية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الإفصاح أو الإتلاف. تشمل هذه التدابير:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>تشفير البيانات أثناء النقل والتخزين</li>
                <li>ضوابط وصول صارمة لحماية قواعد البيانات</li>
                <li>مراجعة دورية لممارسات الأمان</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                5. حقوقك
              </h2>
              <p>
                لديك الحق في:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>الوصول إلى معلوماتك الشخصية وتحديثها</li>
                <li>طلب حذف حسابك ومعلوماتك</li>
                <li>إلغاء الاشتراك في الإشعارات</li>
                <li>سحب الموافقة على معالجة البيانات في أي وقت</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                6. الإشعارات
              </h2>
              <p>
                قد نرسل لك إشعارات بخصوص:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 space-y-1">
                <li>أوقات الصلاة اليومية</li>
                <li>الفعاليات والمناسبات الخاصة بالمسجد</li>
                <li>تحديثات مهمة حول الخدمات</li>
              </ul>
              <p className="mt-2">
                يمكنك إدارة تفضيلات الإشعارات من إعدادات التطبيق في أي وقت.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                7. البيانات الموقعية
              </h2>
              <p>
                نستخدم بيانات موقعك لتحديد أوقات الصلاة بدقة بناءً على موقعك الجغرافي. يمكنك السماح أو رفض الوصول إلى موقعك من خلال إعدادات جهازك.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                8. الأطفال
              </h2>
              <p>
                تطبيقنا غير موجه للأطفال دون سن 13 عامًا. نحن لا نجمع معلومات شخصية عن قصد من الأطفال دون سن 13 عامًا.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                9. التغييرات على سياسة الخصوصية
              </h2>
              <p>
                قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإخطارك بأي تغييرات عن طريق نشر السياسة الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث" أدناه.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-text-primary mb-3">
                10. اتصل بنا
              </h2>
              <p>
                إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا عبر:
              </p>
              <div className="mt-2 space-y-1">
                <p>البريد الإلكتروني: privacy@masjid.com</p>
                <p>الهاتف: +20 123 456 7890</p>
              </div>
            </section>

            <div className="mt-8 pt-6 border-t border-primary-light text-center text-sm">
              <p className="text-text-secondary">
                آخر تحديث: {new Date().toLocaleDateString('ar-EG', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
